import React, { useMemo } from 'react';
import { XtramSelect } from '../Widgets/XtramModal/XtramModal';
import styles from './BankXtram.module.scss';

const SEARCH_FIELDS = ['label', 'value', 'name', 'makat', 'cardId', 'accountCaseId', 'externalSoftwareCardNumber'];

const isAddItem = (option) => option?.value === 'AddItem' || option?.value1 === 'AddItem';

const sameCard = (a, b) => a?.value === b?.value || (a?.cardId != null && a.cardId === b?.cardId);

const filterAccountCards = (options, { inputValue }) => {
    const term = inputValue.trim().toLowerCase();
    if (!term) return options;
    return options.filter((option) =>
        SEARCH_FIELDS.some((field) => option[field] != null && String(option[field]).toLowerCase().includes(term))
    );
};

/**
 * The account card picker of the bank and card screens in Xtram style. Keeps the
 * `(event, card)` onChange contract of AutocompleteSelect so page handlers stay unchanged.
 */
const AccountCardSelect = ({ options, value, onChange, placeholder, direction = 'rtl', className }) => {
    const selectable = useMemo(() => (options || []).filter((option) => option && !isAddItem(option)), [options]);
    const selected = useMemo(
        () => (value ? selectable.find((option) => sameCard(option, value)) || value : null),
        [selectable, value]
    );

    return (
        <div className={className || styles.cardSelect}>
            <XtramSelect
                direction={direction}
                options={selectable}
                value={selected}
                onChange={(option) => onChange?.(null, option)}
                placeholder={placeholder}
                filterOptions={filterAccountCards}
                isOptionEqualToValue={sameCard}
            />
        </div>
    );
};

export default AccountCardSelect;
